import { Button, ButtonGroup, Modal } from "@datapay-by-datacom/design-system";
import { Heading } from "react-aria-components";
import type { MyPayEnvironment } from "../../generated/core-api";
import s from "./CommitImportConfirmModal.module.css";

interface CommitImportConfirmModalProps {
  isOpen: boolean;
  rowCount: number;
  companyName: string;
  companyCode: string;
  environment: MyPayEnvironment;
  componentColumn: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export function CommitImportConfirmModal({
  isOpen,
  rowCount,
  companyName,
  companyCode,
  environment,
  componentColumn,
  onCancel,
  onConfirm,
}: CommitImportConfirmModalProps) {
  return (
    <Modal isOpen={isOpen}>
      <div className={s.modalContent}>
        <Heading slot="title" className={s.title}>
          Confirm import?
        </Heading>
        <dl className={s.summary}>
          <dt className={s.summaryLabel}>Rows</dt>
          <dd className={s.summaryValue}>{rowCount}</dd>
          <dt className={s.summaryLabel}>Company</dt>
          <dd className={s.summaryValue}>
            {companyName} ({companyCode})
          </dd>
          <dt className={s.summaryLabel}>Environment</dt>
          <dd className={s.summaryValue}>{environment}</dd>
          <dt className={s.summaryLabel}>Component column</dt>
          <dd className={s.summaryValue}>{componentColumn}</dd>
        </dl>
        <p className={s.warning}>
          Pay component values will be written for the rows shown in review.
        </p>
        <div className={s.actions}>
          <ButtonGroup>
            <Button variant="tertiary" onPress={onCancel}>
              Cancel
            </Button>
            <Button variant="primary" onPress={onConfirm}>
              Import
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Modal>
  );
}
